"use client";
import { PropsWithChildren } from "react";
import AlchemyProvider from "@shared/src/providers/alchemyProvider";
import { cookieToInitialState, WagmiProvider } from "wagmi";
import { wagmiConfig } from "@shared/src/config/wagmiConfig";

interface Web3ProvidersProps extends PropsWithChildren {
  networks?: any;
}

export function Web3Provider({ children }: Web3ProvidersProps) {
  //TODO: Add chains to wagmiConfig
  const cookie = typeof window !== "undefined" ? document.cookie : "";
  const initialState = cookieToInitialState(wagmiConfig, cookie);

  return (
    <WagmiProvider config={wagmiConfig} initialState={initialState}>
      <AlchemyProvider cookie={cookie}>{children}</AlchemyProvider>
    </WagmiProvider>
  );
}
